module.exports = __webpack_public_path__ + "img/button.7c5e16ad.svg";